import api from "./api.service";
import { tokenService } from "./token.service";

export interface CancelOrderData {
    Id: number;
}

export interface CancelOrderResponse {
    statusCode: number;
    message: string;
}

class CancelOrderService {
    async cancelOrder(data: CancelOrderData): Promise<CancelOrderResponse> {
        const token = tokenService.getToken();
        try {
            const response = await api.post<CancelOrderResponse>(
                "/cancel-order",
                data,
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error cancelling order:", error);
            throw error;
        }
    }
}

export const cancelOrderService = new CancelOrderService();

